import React from "react";
import "./Livia.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Livia7images from "../../media/GW/Livia/Livia 7/Livia7";
import Livia8images from "../../media/GW/Livia/Livia 8/Livia8";
import Livia9images from "../../media/GW/Livia/Livia 9/Livia9";

const imageMap = {
  Livia7images,
  Livia8images,
  Livia9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
